<template>
    <section class="tile h-100">
        <div class="container h-100 mw-100 border-2" :class="isSelected ? 'selected-tile' : ''">
            <div class="row bg-white">
                <div class="col-12 bg-header-tile" :style="'background-image: url('+ offer.backgroundImage +');'">
                    <div class="row">
                        <!--/* BANNIERE + TIMER */-->
                        <div v-if="offer.banner" class="col-12">
                            <div class="tag-timer">
                                <div class="row align-items-center">
                                    <!--/* BANNER */-->
                                    <div class="col-auto p-0">
                                        <div class="ob1-tag ob1-tag-primary">
                                            <span>{{ offer.banner }}</span>
                                        </div>
                                    </div>
                                    <!--/* TIMER */-->
                                    <div v-if="offer.timerEndDateInMilliseconds" class="col-auto">
                                        <timer
                                            :end-date-in-milliseconds="offer.timerEndDateInMilliseconds"
                                            :color="offer.countDownColor ? offer.countDownColor : 'text-dark'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <div class="tag-timer" />
                        </div>

                        <!--/* TEXTUELS A GAUCHE */-->
                        <div class="pt-1" :class="offer.duoDiscountedPriceConnectedTitle ? 'col-12 ' : 'col-7 pe-0'">
                            <!--/* NOM DE L'OFFRE */-->
                            <div>
                                <div class="title-align">
                                    <h2 class="visually-hidden">
                                        {{ offer.name }}
                                    </h2>
                                    <p class="pt-md-1 py-0 mb-0 fw-bold" aria-hidden="true">
                                        {{ offer.offerType }}
                                    </p>
                                    <h2 v-if="offer.secondaryShortLabel" class="h1 py-0 mb-0 pb-1" aria-hidden="true">
                                        {{ offer.secondaryShortLabel }}
                                    </h2>
                                    <h2 v-else class="h4 py-0 mb-0 pb-1" aria-hidden="true">
                                        {{ offer.name }}
                                    </h2>
                                </div>
                                <div>
                                    <p v-if="priceTitle" class="fw-bold mb-0 pt-0 title-price-align">
                                        {{ priceTitle }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!--/* VISUEL A DROITE */-->
                        <div class="col-5 px-0 pt-1 text-center">
                            <div v-if="offer.visualUrl">
                                <img
                                    width="100%"
                                    style="max-width: 120px;"
                                    :alt="offer.visualAlt"
                                    :src="offer.visualUrl"
                                >
                            </div>
                        </div>

                        <div class="col-12 pb-1">
                            <PriceWithDetails
                                class="price-align"
                                :price="offer.price"
                                :price-details-popin="offer.priceDetailsPopin ?? undefined"
                                :offer-id-seo="offer.offerSeoId"
                                :offer-name="offer.name"
                                :tracking-category="priceDetailsTrackingCategory"
                            />
                        </div>

                        <div class="col-12">
                            <div class="mobileprice-odrmention-align">
                                <!--/* PRIX CLIENT MOBILE */-->
                                <AdditionalPrice
                                    v-if="offer.mobileDiscountedPrice"
                                    :title="offer.mobileDiscountedPriceTitle"
                                    :promotion-type="offer.mobileDiscountedPrice.promotionType"
                                    :promotion-duration="offer.mobileDiscountedPrice.duration"
                                    :promotion-price="offer.mobileDiscountedPrice.price"
                                    :initial-price="offer.mobileDiscountedPrice.initialPrice"
                                />

                                <!--/* PERMANENT ODR MENTION */-->
                                <ul class="row list-unstyled mb-0" aria-label="Offres de remboursement">
                                    <li v-for="(odr, index) in offer.permanentOdrMentionBlock" :key="index">
                                        <InlinePromise
                                            :claim="{ attributes: { textHtml: odr } }"
                                            :is-warning="true"
                                            :compact-text="true"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="cart-item-status-align">
                                <ob1-message-alerte
                                    v-if="offer.addedToCart"
                                    type="success"
                                    :title="offer.alreadyInCartLabel"
                                />
                            </div>
                        </div>

                        <!--/* TAGS Attributs offre */-->
                        <div class="col-12">
                            <div class="keywords-align">
                                <div v-if="offer.keyWords">
                                    <OfferTagsList :key-words="offer.keyWords" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 pb-1">
                    <!--/* CTA */-->
                    <div class="pt-1 text-center">
                        <div v-if="offer.genericButtonCta">
                            <generic-button-cta
                                :dto-from-object="offer.genericButtonCta"
                                :css-classes="'btn-primary w-100 mw-100'"
                            />
                        </div>
                    </div>

                    <!--/* CTA Comparateur (Réassurance fibre) */-->
                    <div v-if="comparatorCta" class="pt-1 text-center">
                        <generic-button-cta
                            :dto-from-object="comparatorCta"
                            :css-classes="'btn-secondary w-100 mw-100'"
                        />
                    </div>
                    <div v-if="!offer.genericButtonCta && offer.selectButton">
                        <div v-if="isSelected" class="internet-selection h-100">
                            <span class="mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100">
                                <span class="icon icon-tick-circle" style="font-size: 1.5rem" aria-hidden="true" />
                                <span class="lead fw-bold ms-1">{{ buttonLabel }}</span>
                            </span>
                        </div>
                        <div v-else class="internet-selection">
                            <button
                                class="px-1 px-lg-2 btn btn-secondary w-100"
                                type="button"
                                :data-oevent-category="offer.selectButtonTms.category"
                                :data-oevent-action="offer.selectButtonTms.action"
                                :data-oevent-label="offer.selectButtonTms.label"
                                @click="onSelectOffer()"
                            >
                                {{ buttonLabel }}
                            </button>
                        </div>
                    </div>
                </div>

                <!--/* LIEN FICHE DETAIL OFFRE */-->
                <div class="col-12 pb-2">
                    <div class="detail-link-align d-flex justify-content-center">
                        <a
                            v-if="showDetailPage && detailPageUrl && showDetailPageBtnLabel"
                            :id="'discover-offer-link-'+ offerTileIndex"
                            :href="detailPageUrl"
                            class="ob1-link-arrow"
                            :data-oevent-action="offer.showOfferDetailPageBtnTms.action"
                            :data-oevent-category="offer.showOfferDetailPageBtnTms.category"
                            :data-oevent-label="offer.showOfferDetailPageBtnTms.label"
                        >
                            {{ showDetailPageBtnLabel }}
                        </a>
                    </div>
                </div>
            </div>

            <!--/* ATTRIBUTES */-->
            <div class="row bg-white">
                <div
                    class="offer-edito-content col-12"
                    :data-oevent-category="offer.popinTmsDTO.category"
                    :data-oevent-label="offer.popinTmsDTO.label"
                >
                    <div
                        v-for="(attribute, index) in offer.attributes"
                        :key="index"
                    >
                        <div v-if="attribute.hasTopSeparator" class="col-12">
                            <hr class="my-0">
                        </div>
                        <div class="d-flex mb-1">
                            <div v-if="attribute.image" class="offer-tile-attribute-image me-1">
                                <span
                                    class="icon lead text-primary"
                                    aria-hidden="true"
                                    :class="attribute.image"
                                />
                            </div>
                            <div>
                                <span
                                    :class="['font-size-14 media-body-description-'+index]"
                                    v-html="attribute.description"
                                />
                                <strong
                                    v-if="attribute.tag"
                                    class="ob1-tag ob1-tag-small ob1-tag-specific"
                                    v-html="attribute.tag"
                                />
                            </div>
                        </div>
                    </div>

                    <ul class="row list-unstyled" aria-label="Avantages de l'offre">
                        <li v-for="(visualClaim, index) in offer.claims" :key="`claim-${index}`" class="col-12 pb-1">
                            <InlinePromise :claim="visualClaim" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import GenericButtonCta from "../../../../../common/broadband/components/GenericButtonCta.vue";
import InlinePromise from "../../../../../common/components/ob1/InlinePromise.vue";
import PriceWithDetails from "../../../../../common/components/custom/PriceWithDetails.vue";

import OfferTagsList from "./OfferTagsList.vue";
import AdditionalPrice from "./AdditionalPrice.vue";

export default {
    name: "NewInternetOfferTile",
    components: {
        AdditionalPrice,
        PriceWithDetails,
        InlinePromise,
        GenericButtonCta,
        OfferTagsList
    },
    props: {
        offer: {type: Object, required: true},
        comparatorCta: {type: Object, required: false},
        offerTileIndex: {type: Number, required: true},
        showMobileClientOffers: {type: Boolean, default: false},
        showDetailPage: {type: Boolean, default: false},
        showDetailPageBtnLabel: {type: String, default: "Voir le détail"},
        isSelected: {type: Boolean, default: false}
    },
    computed: {
        detailPageUrl() {
            if (this.showDetailPage) {
                return this.offer.detailPageUrl;
            }
            return undefined
        },
        offerHtmlName() {
            const offerName = this.offer.name.trim();
            return (offerName.startsWith("Livebox ")) ? offerName.replace(" Fibre", "<br>Fibre") : offerName;
        },
        priceCustomClasses() {
            if (this.showMobileClientOffers && this.offer.crossDiscountInfo) {
                return 'h3 text-primary price-icon icon ob1-price-compact ' + this.offer.crossDiscountInfo.bannerIcon;
            } else {
                return 'h3 text-primary ob1-price-compact';
            }
        },
        priceTitle() {
            if (this.offer.duoDiscountedPriceConnectedTitle) {
                return this.offer.duoDiscountedPriceConnectedTitle
            } else if(this.offer.priceConnectedTitle) {
                return this.offer.priceConnectedTitle
            }
            return null
        },
        priceDetailsTrackingCategory() {
            return this.offer.showOfferDetailPageBtnTms.category;
        },
        showAuthenticateButton() {
            return this.showMobileClientOffers && this.offer.authenticateDTO;
        },
        buttonLabel() {
            if (this.isSelected) {
                return this.offer.selectedButtonLabel
            } else return this.offer.selectButtonLabel;
        }
    },
    methods: {
        onSelectOffer() {
            this.$emit('select-offer', this.offer.seoId);
        },
        toggleAttributes() {
            this.$emit('toggle-collapsible-attributes');
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.bg-header-tile {
    background-repeat: no-repeat;
    background-size: 100% auto;
}

.border-2 {
    border: px-to-rem(2) solid $gray-lighter;
}

.border-top-bottom-2 {
    border-top: px-to-rem(2) solid $gray-lighter;
    border-bottom: px-to-rem(2) solid $gray-lighter;
}

.selected-tile {
    border: 0.0625rem solid $brand-orange;
    box-shadow: 0.125rem 0.125rem $brand-orange;
}

.ob1-tag.ob1-tag-specific {
    color: #fff;
    background-color: #000;
}

.offer-tile-attribute-image {
    min-width: 16px;
    min-height: 16px;
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        min-width: 18px;
        min-height: 18px;
    }
}
</style>
